module.exports = __webpack_public_path__ + "static/media/han_cab_che.138ad55b.png";